/**
 * Cat mascot interaction (mouse tracking)
 * - Supports multiple mascots on the page (header + footer)
 * - Moves head slightly + pupils more, based on cursor position.
 */
(function () {
  const init = () => {
    const containers = Array.from(document.querySelectorAll('.cat-mascot'));
    if (!containers.length) return;

    const mascots = containers
      .map((container) => ({
        headGroup: container.querySelector('.cat-head-group'),
        pupilsGroup: container.querySelector('.cat-pupils'),
      }))
      .filter((m) => m.headGroup && m.pupilsGroup);

    if (!mascots.length) return;

    let raf = null;
    let lastX = 0;
    let lastY = 0;

    const apply = () => {
      raf = null;
      const headX = lastX * 6;
      const headY = lastY * 6;
      const pupilX = lastX * 3;
      const pupilY = lastY * 3;

      mascots.forEach(({ headGroup, pupilsGroup }) => {
        headGroup.style.transform = `translate(${headX}px, ${headY}px)`;
        pupilsGroup.style.transform = `translate(${pupilX}px, ${pupilY}px)`;
      });
    };

    const onMove = (e) => {
      const windowWidth = window.innerWidth || 1;
      const windowHeight = window.innerHeight || 1;
      lastX = (e.clientX / windowWidth - 0.5) * 2;
      lastY = (e.clientY / windowHeight - 0.5) * 2;

      if (!raf) raf = window.requestAnimationFrame(apply);
    };

    window.addEventListener('mousemove', onMove, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
